var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMore(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.29945 13.802C6.29326 13.802 7.09891 12.9964 7.09891 12.0026C7.09891 11.0088 6.29326 10.2031 5.29945 10.2031C4.30564 10.2031 3.5 11.0088 3.5 12.0026C3.5 12.9964 4.30564 13.802 5.29945 13.802Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7018 13.802C20.6956 13.802 21.5012 12.9964 21.5012 12.0026C21.5012 11.0088 20.6956 10.2031 19.7018 10.2031C18.708 10.2031 17.9023 11.0088 17.9023 12.0026C17.9023 12.9964 18.708 13.802 19.7018 13.802Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4987 13.802C13.4925 13.802 14.2981 12.9964 14.2981 12.0026C14.2981 11.0088 13.4925 10.2031 12.4987 10.2031C11.5049 10.2031 10.6992 11.0088 10.6992 12.0026C10.6992 12.9964 11.5049 13.802 12.4987 13.802Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.18e976f8a2832b1958b7f170fffc8e06.svg";
export { ForwardRef as ReactComponent };